export default __webpack_public_path__ + "static/404-header-da9b7b9c1bcd7615e6daf22ca2f832d7.png";